import * as React from 'react';
import {
  RadioButtonLabel,
  RadioButton,
  Label,
  Container,
} from './radioButton-components';
type Props = {
  type?: string;
  label: string;
  name?: string;
  value: string;
  onChange?: (e: any) => void;
  checked: boolean;
  register?: any;
  onClick?: (e: any) => void;
};

export default function Input({
  type = 'radio',
  label,
  name = 'radio',
  value,
  onChange,
  checked,
  register,
  onClick,
}: Props) {
  return (
    <Container>
      <RadioButton
        type={'radio'}
        checked={checked}
        value="Individual"
        onChange={onChange}
      />
      <RadioButtonLabel />
      <Label>{label}</Label>
    </Container>
  );
}
